module.exports = __webpack_public_path__ + "static/media/ai.b3fbdf3b.svg";